import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'
import { HeadingSmall, HeadingSmallProps } from './HeadingSmall'

export interface HeadingProps extends HeadingSmallProps {}

const HEADING_STYLES = 'text-4xl text-secondary font-extrabold'

export const Heading: React.FC<PropsWithChildren<HeadingProps>> = ({
  bold = true,
  textTransform,
  margin,
  className,
  children,
}) => (
  <HeadingSmall
    bold={bold}
    textTransform={textTransform}
    margin={margin}
    className={concatStyles([HEADING_STYLES, className])}
  >
    {children}
  </HeadingSmall>
)

Heading.displayName = 'Content.Heading'
